import React from "react";

const Piscis = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 120" {...r}>
      <path
        fill="#0250C9"
        d="M89.622 57.505h-15.14c.73-14.971 9.899-22.072 10.337-22.396a3.947 3.947 0 00.848-5.498 3.905 3.905 0 00-5.475-.852c-.542.397-12.769 9.605-13.535 28.746H52.923c-.779-19.141-12.994-28.349-13.535-28.746a3.905 3.905 0 00-5.472.867 3.946 3.946 0 00.864 5.496c.097.073 9.563 7.204 10.336 22.383h-15.2a3.907 3.907 0 00-2.77 1.152 3.94 3.94 0 000 5.561 3.907 3.907 0 002.77 1.152h14.786c-1.988 12.596-9.728 19.276-10.092 19.58a3.927 3.927 0 00-1.503 2.673 3.948 3.948 0 00.867 2.943 3.921 3.921 0 002.71 1.42 3.901 3.901 0 002.9-.966c.492-.403 10.859-9.208 13.011-25.645H67.01c2.146 16.443 12.519 25.248 13.005 25.644a3.912 3.912 0 002.876.905 3.903 3.903 0 002.664-1.415 3.936 3.936 0 00.874-2.897 3.946 3.946 0 00-1.434-2.662c-.091-.079-8.062-6.82-10.093-19.581H89.64a3.907 3.907 0 002.769-1.152 3.94 3.94 0 000-5.56 3.907 3.907 0 00-2.77-1.153h-.017z"
      ></path>
    </svg>
  );
}

export default Piscis;